module.exports = __webpack_public_path__ + "static/media/icon-six.d4b5e93a.webp";